// extracted by mini-css-extract-plugin
export var container = "_d2-0";
export var popoverContent = "_d2-1";
export var tosLink = "_d2-2";